import { logi, useScript } from "@sista/library-stasi";

import { Metadata } from "../../utils/IdmUiContext";

export function runReCaptcha(
  metadata: Metadata,
  action: string
): Promise<string> {
  const recaptcha = metadata["REACT_APP_RECAPTCHA"];
  if (recaptcha == "noop") {
    return Promise.resolve("noop");
  }
  logi("Getting captcha code for action", action);
  return new Promise<string>((resolve, reject) => {
    // @ts-ignore
    grecaptcha.ready(function () {
      try {
        // @ts-ignore
        grecaptcha
          .execute(recaptcha, { action: action })
          .then(function (token: string) {
            resolve(token);
          });
      } catch (e) {
        reject(e);
      }
    });
  });
}

export const ReCaptchaScript = (props: { metadata: Metadata }) => {
  console.log("ReCaptchaScript", props.metadata);
  const recaptcha = props.metadata["REACT_APP_RECAPTCHA"];
  if (recaptcha == "noop") {
    return <></>;
  }
  const url = "https://www.google.com/recaptcha/api.js?render=" + recaptcha;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useScript(url);
  return <></>;
};

export default ReCaptchaScript;
